<template>
  <div class="number-input">
    <div class="number-input__label">from</div>
    <div class="number-input__input-wrapper">
      <input class="number-input__input" v-model="minValue" v-bind:aria-label="minValue">
      <div class="number-input__controls">
        <div type="button" class="number-input__deacrese number-input__control-btn" v-on:click="minValue++"><i class="icon-angle-up" aria-label="Increase"></i></div>
        <div type="button" class="number-input__increase number-input__control-btn" v-on:click="minValue--"><i class="icon-angle-down" aria-label="Decrease"></i></div>
      </div>
    </div> 
    <div class="number-input__label">to</div>
    <div class="number-input__input-wrapper">
      <input class="number-input__input" v-model="maxValue" v-bind:aria-label="maxValue">
      <div class="number-input__controls">
        <div type="button" class="number-input__deacrese number-input__control-btn" v-on:click="maxValue++"><i class="icon-angle-up" aria-label="Increase"></i></div>
        <div type="button" class="number-input__increase number-input__control-btn" v-on:click=" maxValue--"><i class="icon-angle-down" aria-label="Decrease"></i></div>
      </div>
    </div> 
  </div>  
</template>

<script>
export default {
  name: "NumberInput",
  props: ['field', 'value'],
  data() {
    return {
      min: this.field.Values[0],
      max: this.field.Values[1]
    };
  },
  mounted() {
    if (!this.value) {
        this.$emit('input', [this.minValue, this.maxValue]);
    }
  },
  computed: {
    minValue: {
      get() {
        if ( this.value && this.value.length) {
          return this.value[0]; 
        }
        return this.min;
      },
      set(value) {
        if (this.min <= value && value <= this.maxValue) {
          this.$emit('input',[value,this.maxValue]);
        }
      }
    },
    maxValue: {
      get() {
        if ( this.value && this.value.length) {
          return this.value[1]; 
        }
        return this.max;
      },
      set(value) {
        if (this.max >= value && value >= this.minValue) {
          this.$emit('input',[this.minValue,value]);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/scss/variables';

.number-input {
  flex-basis: 55%;
  height: 40px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  @media (max-width: 767px) {
    width: 100%;
  }
  & > * {
    box-sizing: border-box;
  }
  &__input {
    width: 100%;
    height: 100%;
    padding: 0 25px 0 10px;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;   
    outline: none;
    font-family: $main-font;
  }
  &__input-wrapper {
    position: relative;
    height: 100%;
    width: 90px;
    margin: 0 10px;
  }
  &__controls {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    box-sizing: border-box;
  }
  &__control-btn {
    cursor: pointer;
    width: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:first-child {
      border-bottom-width: 1px;
      border-bottom-style: solid;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-inputs/NumberInput.vue